<template>
  <user-dropdown
    :company-name="agencyName"
    profile-route-path="/account-settings/beneficiary"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
import { useAgencyById } from '@/services/agencies/queries.js';
import UserDropdown from '@/components/user/UserDropdown.vue';

const authStore = useAuthStore();
const { data: agency } = useAgencyById(authStore.agencyId);
const agencyName = computed(() => agency.value?.data?.name || '');
</script>
